import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaLinkedin, FaInstagram, FaTiktok, FaEnvelope, FaPhoneAlt, FaEnvelopeOpen } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const FooterOne = ({ parentClass }) => {
    const { t } = useTranslation();

    return (
        <footer className={`footer-area ${parentClass}`}>
            <div className="container">
                <div className="footer-top">
                    <div className="footer-social-link">
                        <ul className="list-unstyled">
                            <li><a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} aria-label="Our Email Address"><FaEnvelope /> {process.env.REACT_APP_SUPPORT_EMAIL}</a></li>
                            <li><a href="tel:+41798973949" aria-label="Our Phone Contact"><FaPhoneAlt /></a></li>
                            <li><a href="https://www.facebook.com/profile.php?id=61555118053035" aria-label="Our Facebook Page"><FaFacebookF /></a></li>
                            <li><a href="https://www.linkedin.com/in/sousa-elec-4197742a8/" aria-label="Our Linkedin Page"><FaLinkedin /></a></li>
                            <li><a href="https://www.instagram.com/sousa.elec/" aria-label="Our Instagram Page"><FaInstagram /></a></li>
                            <li><a href="https://www.tiktok.com/@sousaelec" aria-label="Our TikTok Page"><FaTiktok /></a></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-main">
                    <div className="row">
                        <div className="col-xl-6 col-lg-5">
                            <div className="footer-widget border-end">
                                <div className="footer-newsletter">
                                    <span className="h2 title">{t('Get in touch!')}</span>
                                    <p>{t('Introduza o seu email se pretender receber atualizações e novidades!')}</p>
                                    <form>
                                        <div className="input-group">
                                            <span className="mail-icon"><FaEnvelopeOpen /> </span>
                                            <input id='email-for-newsletter' type="email" className="form-control" placeholder="Email address" />
                                            <button className="subscribe-btn dark_text_color" type="submit">{t('Subscribe')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7">
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="footer-widget">
                                        <p className="widget-title h6">{t('Electricité')}</p>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to={"/service-Courant_Fort"}>{t('courantfort')}</Link></li>
                                                <li><Link to={"/service-Courant_Faible"}>{t('courantfaible')}</Link></li>
                                                <li><Link to={"/service-Audiovisuel"}>{t('Audiovisuel')}</Link></li>
                                                <li><Link to={"/service-Securite"}>{t('Securite')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <div className="footer-widget">
                                        <p className="widget-title h6">{t('Energie renouvelable')}</p>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to={"/service-Productiondenergie"}>{t('Production d\'énergie')}</Link></li>
                                                <li><Link to={"/service-Stockagedenergie"}>{t('Stockage d\'énergie')}</Link></li>
                                                <li><Link to={"/service-Gestiondenergie"}>{t('Gestion d\'énergie')}</Link></li>
                                                <li><Link to={"/service-Maintenance"}>{t('Maintenance')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="footer-widget">
                                        <p className="widget-title h6">{t('Informatique')}</p>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to={"/service-Developpement"}>{t('Developpement')}</Link></li>
                                                <li><Link to={"/service-Web"}>{t('Web')}</Link></li>
                                                <li><Link to={"/service-Integration"}>{t('Integration')}</Link></li>
                                                <li><Link to={"/service-StrategieSociale"}>{t('Strategie Sociale')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="footer-copyright">
                                <span className="copyright-text">© {new Date().getFullYear()}. {process.env.REACT_APP_APP_NAME}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="footer-bottom-link">
                                <ul className="list-unstyled">
                                    <li><Link to={"/contact"}>{t('Contact')}</Link></li>
                                    <li><Link to={"/privacy-policy"}>{t('Privacy Policy')}</Link></li>
                                    <li><Link to={"/terms-use"}>{t('Terms of Use')}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterOne;